// @flow

export const request = async (
  path: string,
  method: string,
  headers: any,
  body: BodyInit,
  handleErrors: ({ [string]: Array<string> }) => void,
  successCallback: (any) => void = () => {}
): Promise<boolean> => {
  try {
    let defaultHeaders = {
      'Content-Type': 'application/json',
      'X-App-Token': getAppToken(),
    }
    const requestOptions = {
      method: method,
      headers: Object.assign(defaultHeaders, headers),
      body: body,
    }

    const response = await fetch(path, requestOptions)
    let data

    switch (response.status) {
      case 200:
        data = await response.json()
        successCallback(data)
        return true
      case 204:
        successCallback()
        return true
      case 422:
        data = await response.json()
        handleErrors(data.errors)
        break
      default:
        defaultError(handleErrors)
    }
  } catch {
    defaultError(handleErrors)
  }

  return false
}

function defaultError(handleErrors) {
  handleErrors({
    non_field_errors: [
      'Something went wrong. Please refresh this page and try again. ' +
        'If the problem persists, let us know at billing@dr-bill.ca',
    ],
  })
}

export const getCsrfToken = (): string => {
  const csrfTag: ?HTMLElement = document.querySelector("meta[name='csrf-token']")
  const csrfToken: ?string = csrfTag?.getAttribute('content')

  if (csrfToken) {
    return csrfToken
  } else {
    const error = new Error('Unable to find csrf-token')
    window.newrelic.noticeError(error)
    return ''
  }
}

export const getAppToken = (): string => {
  const appTokenTag: ?HTMLElement = document.querySelector("meta[name='web-app-token']")
  const appToken: ?string = appTokenTag?.getAttribute('content')

  if (appToken) {
    return appToken
  } else {
    const error = new Error('Unable to find app-token')
    window.newrelic.noticeError(error)
    return ''
  }
}
